import { css } from '@emotion/css';

export const responsiveMenuItemStyles = css`
  .MenuItem-startIcon {
    width: 2.4rem;
    height: 2.4rem;
    margin-inline-end: 2rem;
  }
`;
